import createReactComponent from '../createReactComponent';
export default createReactComponent('transition-left', 'IconTransitionLeft', [
  ['path', { d: 'M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3', key: 'svg-0' }],
  ['path', { d: 'M21 6v12a3 3 0 0 1 -6 0v-12a3 3 0 0 1 6 0z', key: 'svg-1' }],
  ['path', { d: 'M15 12h-8', key: 'svg-2' }],
  ['path', { d: 'M10 9l-3 3l3 3', key: 'svg-3' }],
]);
